/**
 *
 * Asynchronously loads the component for NewsPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const BannerPage = lazyLoad(
  () => import('./index'),
  module => module.BannerPage,
);
